import { render, staticRenderFns } from "./DetailHistoryTab.vue?vue&type=template&id=1d3eeedf&scoped=true&"
import script from "./DetailHistoryTab.vue?vue&type=script&lang=ts&"
export * from "./DetailHistoryTab.vue?vue&type=script&lang=ts&"
import style0 from "./DetailHistoryTab.vue?vue&type=style&index=0&id=1d3eeedf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3eeedf",
  null
  
)

export default component.exports